import { notification } from "antd";
import {
  UPDATE_FORM_REQUEST,
  UPDATE_FORM_SUCCESS,
  UPDATE_FORM_FAILURE,
} from "../Types";
import { apiPut } from "../../services/apiInterceptor";

export const updateFormulaire = (formId, updatedData) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_FORM_REQUEST });

    try {
      // ✅ MIGRATION : Plus besoin de gérer manuellement le token et les headers
      const response = await apiPut(`api/forms/${formId}`, updatedData);

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data?.message || "Erreur lors de la mise à jour du formulaire"
        );
      }

      dispatch({ type: UPDATE_FORM_SUCCESS, payload: data });

      notification.success({
        message: "Formulaire mis à jour avec succès" || data?.message,
        duration: 5,
      });

      return data;
    } catch (error) {
      dispatch({ type: UPDATE_FORM_FAILURE, payload: error?.message });

      notification.error({
        message:
          error?.message || "Erreur lors de la mise à jour du formulaire",
        duration: 5,
      });
    }
  };
};
